import React, { useEffect, useState } from "react";

import { ChatContextData } from "../../../../../context/ChatContext/ChatContext";
import { findUserAvatarByUserId, findUserById } from "../ChatScripts";
import { useSelector } from "react-redux";
import { Button } from "../../../../BP2Components";

import "../ChatStyle.less";
import { ChatSettingsState } from "../../../../../appRedux/reduxInterfaces/ReducersInterfaces";

interface ChatSettingsUserListProps {
   users: Array<number | string>;
   chatData: ChatContextData;
   // setUsersToRemove is a function that accepts an updater function as its argument.
   // The updater function takes the previous state (prevUsers) as an argument,
   // which is an array of strings or numbers, and returns the new state (updated array of strings or numbers).
   // The setUsersToRemove function does not return anything (void).
   setUsersToRemove: (updater: (prevUsers: (string | number)[]) => (string | number)[]) => void;
   chatSettings: ChatSettingsState;
}

const ChatSettingsUserList: React.FC<ChatSettingsUserListProps> = ({
   users,
   chatData,
   setUsersToRemove,
   chatSettings
}) => {
   const { avatars } = useSelector(({ companies }: any) => companies);

   // this state is only for hidding users that are ment to be removed from current room users list.
   const [hideRoomUsers, setHideRoomUsers] = useState<any>([]);

   const handleSelectUserToRemove = (e: React.MouseEvent, user: string | number) => {
      e.preventDefault();
      setUsersToRemove((prevUsers) => [...prevUsers, user]);
      setHideRoomUsers((prevState) => [...prevState, user]);
   };

   useEffect(() => {
      setHideRoomUsers([]);
   }, [chatSettings?.currentRoom?.chatUsers]);

   return (
      <div>
         {users
            ?.filter((user) => !hideRoomUsers.includes(user)) // Filter out users in hideRoomUsers
            .map((user) => {
               const foundUser = findUserById(user, chatData);
               const userAvatar = findUserAvatarByUserId(user, avatars);
               return (
                  foundUser && (
                     <div className="chat-settings-user-list-container">
                        <div className="chat-settings-user-list-container__user-data" key={user}>
                           <div className="user-chat-settings-avatar">
                              {userAvatar !== null ? (
                                 <img
                                    key={foundUser?.oldId}
                                    src={userAvatar}
                                    style={{
                                       width: "36px",
                                       height: "36px",
                                       borderRadius: "50%",
                                       marginRight: "-5%"
                                    }}
                                 />
                              ) : (
                                 <span
                                    style={{ fontSize: "36px" }}
                                    className="material-symbols-outlined"
                                 >
                                    account_circle
                                 </span>
                              )}
                           </div>
                           {foundUser.firstName} {foundUser.lastName}{" "}
                        </div>
                        <div>
                           <Button
                              onClick={(e) => handleSelectUserToRemove(e, user)}
                              className="remove-buton"
                           >
                              <span className="material-symbols-outlined remove-icon">close</span>
                           </Button>
                        </div>
                     </div>
                  )
               );
            })}
      </div>
   );
};
export default ChatSettingsUserList;
